import styled from 'styled-components';
import close from '../../assets/close.svg';

export const CloseButton = styled.div`
  position: absolute;
  cursor: pointer;
  height: 24px;
  width: 24px;
  background-size: 24px;
  background-repeat: no-repeat;
  opacity: 0.5;
  background: url('${close}');
  z-index: 1;

  &:hover {
    opacity: 0.7;
  }
`;
